import React from "react";

import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import {
  buttonStyles2,
  buttonStyles,
  cardStyles,
  gridStyles,
  typographyStyles,
} from "./style";
import { useSelector} from "react-redux";

const TourCard = ({ t , entityType ,auth , profileSelected}) => {

  const {
    //auth,
    dashboardInfo: {entityProfileSelect}
  } = useSelector((state) => state);
  
  const handleClick = React.useCallback(() => {
    if(entityType == 'DISTRIBUTOR'){
      window.open("https://tomaladaca.gov.pt/recetor/", "_blank");
    }else if(entityType == 'DONOR'){
      window.open("https://tomaladaca.gov.pt/doador/", "_blank");
    }else if(profileSelected == "DISTRIBUTOR"){
      window.open("https://tomaladaca.gov.pt/recetor/", "_blank");
    }else{
      window.open("https://tomaladaca.gov.pt/doador/", "_blank");
    }
   
  }, []); 

  return (
    <Card sx={cardStyles}>
      <Typography sx={typographyStyles} fontSize={"20px"} fontWeight={"600"} fontFamily={"Sitka Heading"}>
        {t("needHelpWithProcess")}
      </Typography>
      <Grid sx={gridStyles}>
        <Button sx={buttonStyles2} size="large" variant="contained" fullWidth onClick={handleClick}>
          {t("clickToTour")}
        </Button>
        {/* <Typography fontSize={"small"} fontWeight={"bold"}>
          {t("commonQuestions")}
        </Typography> */}
      </Grid>
    </Card>
  );
};

export default TourCard;
